import React from "react";
import { Table } from "antd";

const DataTable = ({ columns, dataSource, rowKey = "id", loading = false, summary, onRow, expandable, rowSelection }) => (
  <Table
    className="table datanew dataTable no-footer"
    columns={columns}
    dataSource={dataSource}
    rowKey={rowKey}
    loading={loading}
    // Optional checkbox column (e.g. Leave Management's bulk-mark grid) -
    // antd's own `rowSelection` prop ({selectedRowKeys, onChange, ...}),
    // forwarded straight through. Undefined for every existing caller, so
    // no visual change unless a page opts in.
    rowSelection={rowSelection}
    // Optional grand-totals row - antd's own `summary` render-prop, forwarded
    // straight through. Undefined for every existing caller, so no visual
    // change unless a page opts in.
    summary={summary}
    // Optional whole-row click handler (e.g. a drill-down report where
    // every cell, not just one link column, should navigate) - antd's own
    // `onRow` render-prop, forwarded straight through. Undefined for every
    // existing caller, so no behavior change unless a page opts in.
    onRow={onRow}
    // Optional expand-in-place row detail (e.g. a report row with no real
    // detail page of its own) - antd's own `expandable` prop
    // ({ expandedRowRender, rowExpandable }), forwarded straight through.
    // Undefined for every existing caller, so no behavior change unless a
    // page opts in.
    expandable={expandable}
    // antd merges `pagination` prop over its own internal state on every
    // render (see node_modules/antd/es/table/hooks/usePagination.js -
    // extendsObject(innerPagination, paginationObj, ...), prop wins) - a
    // fixed `pageSize` prop here silently overrode the user's own
    // size-changer selection back to 10 on every re-render, so the "records
    // per page" dropdown never visibly did anything. `defaultPageSize` only
    // seeds the internal state once and leaves it alone after that.
    pagination={{ defaultPageSize: 10, showSizeChanger: true, pageSizeOptions: [10, 20, 50, 100] }}
  />
);

export default DataTable;
